
const platsReducer = (state = [{code: "ALL", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDLINK_PLATS':
      return action.results;
    default:
      break;
  }
  return state;
}

export default platsReducer;